export const auth = {
  get token() {
    return localStorage.getItem("agent_token");
  },
  set token(v) {
    if (v) localStorage.setItem("agent_token", v);
    else localStorage.removeItem("agent_token");
  },
  get user() {
    const raw = localStorage.getItem("agent_user");
    return raw ? JSON.parse(raw) : null;
  },
  set user(v) {
    if (v) localStorage.setItem("agent_user", JSON.stringify(v));
    else localStorage.removeItem("agent_user");
  },
  clear() {
    this.token = null;
    this.user = null;
  },
};